import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BusinessMaster = () => {
  const tableHeaders = ["#", "Image", "Business ", "Description", "Status", "Action"];
  const [businessData, setBusinessData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    id: null,
    vee_business_name: '',
    description: '',
    veemart_business_image: '',
    active_status: 1,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchBusiness();
  }, []);

  const fetchBusiness = async () => {
    try {
      setInitialLoading(true);
      const res = await axios.get(`${var_api}sa_veemart_business_master/get`);
      setBusinessData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch business data", err);
    } finally {
      setInitialLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      vee_business_name: '',
      description: '',
      veemart_business_image: '',
      active_status: 1,
    });
    setFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.vee_business_name.trim()) newErrors.vee_business_name = "Business Name is required";
    if (!isEditMode && !file) newErrors.veemart_business_image = "Image is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    setLoading(true);

    const form = new FormData();
    form.append("vee_business_name", formData.vee_business_name);
    form.append("description", formData.description);
    form.append("active_status", formData.active_status);
    if (file) form.append("veemart_business_image", file);
    else form.append("veemart_business_image", "");

    try {
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_business_master/update/${formData.id}`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        res = await axios.post(`${var_api}sa_veemart_business_master/post`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      toast.success(res?.data?.message || "Business saved successfully");
      setShowModal(false);
      fetchBusiness();
    } catch (err) {
      console.error("Error saving business:", err);
      toast.error(err?.response?.data?.message || "Error occurred while saving");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = businessData.filter(item =>
    Object.values(item).some(val =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search business..."
                  value={searchQuery}
                  onChange={e => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={item.veemart_business_image ? `${image_api}${item.veemart_business_image.replace(/^test\//, '')}` : defaultImg}
                              alt="business"
                              width="40"
                              height="40"
                              className="rounded"
                              style={{ cursor: 'pointer' }}
                              onClick={() => window.open(`${image_api}${item.veemart_business_image.replace(/^test\//, '')}`, '_blank')}
                            />
                          </td>
                          <td>{item.vee_business_name}</td>
                          <td>{item.description}</td>
                          <td>
                            <span className={`badge ${item.active_status === 1 ? 'bg-success' : 'bg-danger'}`}>
                              {item.active_status === 1 ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td>
                            
                              <button
                                className="btn shadow btn-xs sharp"
                                style={{ backgroundColor: "#007bff", color: "white" }}
                                onClick={() => handleEditClick(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                                <button
                              className="btn shadow btn-xs sharp"
                              style={{ backgroundColor: "#28a745", color: "white" }}
                              title="View Category "
                              onClick={() => {
                                localStorage.setItem("business_id", item.id);
                                localStorage.setItem("business_name", item.vee_business_name);
                                navigate(`/vee-category?business_id=${encodeURIComponent(item.id)}`);
                              }}
                            >
                              <i className="fas fa-cubes"></i>
                            </button>
                           
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? "Edit Business" : "Add Business"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
    <Row>
  {/* Business Name */}
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>
        Business <span className="text-danger">*</span>
      </Form.Label>
      <Form.Control
        type="text"
        name="vee_business_name"
        value={formData.vee_business_name}
        placeholder="Enter Business Name"
        onChange={handleInputChange}
        isInvalid={!!errors.vee_business_name}
      />
      <Form.Control.Feedback type="invalid">
        {errors.vee_business_name}
      </Form.Control.Feedback>
    </Form.Group>
  </Col>

  {/* Description */}
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Description</Form.Label>
      <Form.Control
        type="text"
        name="description"
        value={formData.description}
        placeholder="Enter Description"
        onChange={handleInputChange}
      />
    </Form.Group>
  </Col>
</Row>

<Row>
  {/* Active Status (Edit Mode Only) */}
  {isEditMode && (
    <Col md={6}>
      <Form.Group className="mb-3 d-flex align-items-center gap-2">
        <Form.Label className="mb-0">
          {formData.active_status === 1 ? "Active" : "Inactive"}
        </Form.Label>
        <Form.Check
          type="switch"
          id="active-status-switch"
          checked={formData.active_status === 1}
          onChange={(e) =>
            setFormData({
              ...formData,
              active_status: e.target.checked ? 1 : 0,
            })
          }
          className={formData.active_status === 1 ? "custom-switch-green" : ""}
        />
      </Form.Group>
    </Col>
  )}

  {/* Image Upload */}
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>
        Image <span className="text-danger">*</span>
      </Form.Label>
      {isEditMode && formData.veemart_business_image && !file && (
        <div className="mb-2 d-flex gap-2 align-items-center">
          <img
            src={`${image_api}${formData.veemart_business_image.replace(/^test\//, "")}`}
            alt="Preview"
            width="80"
            className="rounded border"
          />
        </div>
      )}
      <Form.Control
        type="file"
        accept="image/*"
        onChange={(e) => setFile(e.target.files[0])}
      />
    </Form.Group>
  </Col>
</Row>


                 <div className="d-flex justify-content-end gap-2">
         {!isEditMode ? (
           <>
             <Button variant="secondary" type="submit" disabled={loading}>
               {loading ? (
                 <>
                   <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                   Creating...
                 </>
               ) : (
                 "Create"
               )}
             </Button>
             <Button
               variant="danger"
               type="reset"
               disabled={loading}
             onClick={() =>
         setFormData({
          id: null,
    vee_business_name: '',
    description: '',
    veemart_business_image: '',
    active_status: 1,
         })
       }
       
             >
               Reset
             </Button>
           </>
         ) : (
           <>
             <Button variant="warning" type="submit" disabled={loading}>
               {loading ? (
                 <>
                   <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                   Updating...
                 </>
               ) : (
                 "Update"
               )}
             </Button>
             <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
               Cancel
             </Button>
           </>
         )}
       </div>
                 
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer />
      <style>{`
        .custom-switch-green .form-check-input:checked {
          background-color: #28a745 !important;
          border-color: #28a745 !important;
        }
      `}</style>
    </>
  );
};

export default BusinessMaster;
